import _extends from "@babel/runtime/helpers/extends";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["children", "inverse", "required", "size", "tooltip", "tooltipProps"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import React, { forwardRef } from 'react';
import { IconInfoBadgedSmallFilled } from '../../assets/icons/components';
import Box from '../box';
import Icon from '../icon';
import Tooltip from '../tooltip';
import { TextBodyCompact, TextDisplay, TextSmall } from '../typography';
var TooltippedIcon = Tooltip(Icon);
var Label = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var children = _ref.children,
    _ref$inverse = _ref.inverse,
    inverse = _ref$inverse === void 0 ? false : _ref$inverse,
    _ref$required = _ref.required,
    required = _ref$required === void 0 ? false : _ref$required,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 'medium' : _ref$size,
    tooltip = _ref.tooltip,
    tooltipProps = _ref.tooltipProps,
    others = _objectWithoutProperties(_ref, _excluded);
  var childProps = {
    inverse: inverse,
    marginTop: 1,
    size: size
  };
  var Element = {
    small: TextBodyCompact,
    medium: TextBodyCompact,
    large: TextDisplay
  }[size];
  return /*#__PURE__*/React.createElement(Box, _extends({
    "data-teamleader-ui": "label",
    display: "block",
    element: "label",
    marginBottom: 3,
    ref: ref
  }, others), React.Children.map(children, function (child) {
    return typeof child !== 'string' && /*#__PURE__*/React.isValidElement(child) ? ( /*#__PURE__*/React.cloneElement(child, _objectSpread(_objectSpread({}, childProps), child.props))) : /*#__PURE__*/React.createElement(Box, {
      display: "flex",
      alignItems: "center"
    }, /*#__PURE__*/React.createElement(Element, {
      color: inverse ? 'neutral' : 'teal',
      tint: inverse ? 'lightest' : 'darkest',
      element: "span"
    }, child), required && /*#__PURE__*/React.createElement(TextSmall, {
      color: "ruby",
      element: "span",
      marginLeft: 1,
      tint: "dark"
    }, "*"), tooltip && /*#__PURE__*/React.createElement(TooltippedIcon, _extends({
      tooltip: /*#__PURE__*/React.createElement(TextSmall, null, tooltip),
      tooltipSize: "small",
      color: inverse ? 'neutral' : 'teal',
      tint: inverse ? 'lightest' : 'darkest',
      marginLeft: 1
    }, tooltipProps), /*#__PURE__*/React.createElement(IconInfoBadgedSmallFilled, null)));
  }));
});
Label.displayName = 'Label';
export default Label;